import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {defaultLabServicesIds} from '../../utils/defaultLabServices';
import _ from 'lodash';
import PersonInfoCard from '../../common/components/PersonInfoCard/PersonInfoCard';
import Table from '../../common/components/ItemTable/v2/Table';
import Loading from '../../common/components/Loading/Loading';
import CustomAlert from '../../common/components/Alert/CustomAlert';
import Ebutton from '../../common/components/Ebutton/Ebutton';
import QuantitySelector from '../../common/components/QuantitySelector/v2/QuantitySelector';
import Button from '../../common/components/Button/Button';
import helpIcon from '../../images/help_h.png';
import SendQuoteForm from './SendQuoteForm';


// Hasta esta cantidad de filas la tabla entra sin scroll y se adapta al contenido;
// de ahi en mas toma el alto maximo (third-step-table-card-fixed) y scrollea.
const MAX_ROWS_WITHOUT_SCROLL = 7;


const ThirdStep = (props) => {
    const {
        switchOfUser,
        approveAttentionState,
        attention,
        createAttentionState,
        attentionForCreate,
        setAttentionForCreate,
        branchesProviders,
        affiliateData,
        affiliateSelected,
        attentionsSelected,
        branches,
        setAttentionsSelected,
        userInfo,
        onFinish,
        isSimulation,
        onExitSimulation,
        approveAttention,
        flagAmount,
        sendQuoteEmailState,
    } = props;
    const history = useHistory();

    const [amount, setAmount] = useState(0);
    const [provider, setProvider] = useState(branches?.find((branch) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
    const [branch, setBranch] = useState(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
    const [attentionsForCreate, setAttentionsForCreate] = useState(attentionForCreate?.coveredByProvider);
    const [showAmount, setShowAmount] = useState(false);

    const hasAmount = (value) => typeof value === 'number' && !Number.isNaN(value);

    const renderPrecio = (params) => (
        <p>{showAmount && hasAmount(params.row.needsToPay) ? `$${params.row.needsToPay.toLocaleString()}` : '***'}</p>
    );
    const renderCantidad = (params) => (
        <QuantitySelector
            value={params.row.count}
            handleChange={(value) => handleChangeCount(params.row.id, value)}
            disable={params.disable}
        />
    );

    const renderSubtotal = (params) => (
        <p>{showAmount && hasAmount(params.row.needsToPay) ? `$${(params.row.needsToPay * params.row.count).toLocaleString()}` : '***'}</p>
    );

    const isNonAffiliate = !!affiliateData?.[0]?.medicalCoverage;

    // Quien puede cotizar puede enviar la cotización. Además solo se ofrece con
    // los montos visibles (el backend vuelve a validar ambas cosas).
    const canSendQuoteEmail = ['ADMIN', 'PROVIDER_ADMIN', 'PROVIDER_USER', 'PROVIDER_USER_QUOTER']
        .includes(userInfo?.role?.name);

    const renderModalidad = (params) => {
        let label;
        if (isNonAffiliate) {
            label = 'Particular';
        } else if (params.row.tariff === 'SI') {
            label = 'Posee arancel preferencial';
        } else if (params.row.needsToPay === 0) {
            label = 'No abona';
        } else if (params.row.tariff === 'NO') {
            label = 'Paga copago';
        } else {
            label = 'Posee arancel preferencial';
        }

        return (
            <span style={{display: 'inline-flex', alignItems: 'center'}}>
                <span>{label}</span>
                {params.row.tooltip && (
                    <img
                        src={helpIcon}
                        alt=""
                        title={params.row.tooltip}
                        style={{width: '14px', height: '14px', marginLeft: '6px', cursor: 'help'}}
                    />
                )}
            </span>
        );
    };

    const listData = [
        {id: 'DESCRIPCIÓN', title: 'Descripción', att: 'medicalServiceName', flex: 2, sort: true},
        {id: 'PRECIO', title: 'Precio', att: 'needsToPay', center: true, flex: 1, renderCell: renderPrecio},
        {id: 'CANTIDAD', title: 'Cantidad', att: 'count', center: true, centerTitle: true, sort: true, renderCell: renderCantidad},
        {
            id: 'SUBTOTAL',
            title: 'Subtotal',
            att: 'subtotal',
            center: true,
            sort: true,
            valueGetter: (p) => p.row.needsToPay * p.row.count,
            renderCell: renderSubtotal,
        },
        {id: 'Modalidad', title: 'Modalidad', att: 'situation', flex: 2, sort: true, renderCell: renderModalidad},
    ];


    useEffect(() => {
        switchOfUser('Crear Atención');
        // setAttentionsSelected(attentionsSelected.map((item) => item.count = 1));
        switch (userInfo.role.name) {
            case 'ADMIN':
                setProvider(branches?.find((branch) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
                setBranch(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                setShowAmount(!flagAmount);
                break;
            case 'PROVIDER_ADMIN':
                setProvider(userInfo.salesforceProviderName);
                setBranch(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                setShowAmount(!flagAmount);
                break;
            case 'PROVIDER_USER':
            case 'PROVIDER_USER_QUOTER':
                setProvider(userInfo.salesforceProviderName);
                setBranch(userInfo.salesforceBranchName);
                setShowAmount(!flagAmount);
                break;
            default:
                break;
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setShowAmount(!flagAmount);
    }, [flagAmount]);

    useEffect(() => {
        if (attention) {
            let sum = 0;
            const list = attention?.coveredByProvider?.filter((att) => !(
                attention?.notCoveredByProvider?.some((x) => x.medicalServiceId === att.medicalServiceId)
            ));
            const updatedList = list.map((att) => ({
                ...att,
                medicalServiceDescription: att.medicalServiceName,
                id: att.medicalServiceId,
            }));
            list.map((att) => {
                sum += att.needsToPay;
            });
            setAmount(sum);
            // The selected ones are the ones used to calculate the total amount
            const listWithPreviousCount = updatedList.map((item) => {
                const count = attentionsSelected.find((attention) => attention.medicalServiceId === item.id)?.count || 1;
                return {...item, count};
            });
            setAttentionsSelected(listWithPreviousCount);
            // The created ones are the ones used to show to the user in the grid
            setAttentionsForCreate(listWithPreviousCount);
            reCalcAmount(listWithPreviousCount);
        }
    }, [approveAttentionState.success, attention]);


    const checkButton = (medicalServicesIds) => {
        const toRemove = [];
        const toAdd = [];

        attentionsForCreate.forEach((attention) => {
            if (medicalServicesIds.find((x) => x === attention.medicalServiceId)) {
                toAdd.push(attention);
            }
        });
        attentionsSelected.forEach((attention) => {
            if (!medicalServicesIds.find((x) => x === attention.medicalServiceId)) {
                toRemove.push(attention);
            }
        });
        setAttentionsSelected(toAdd);
        reCalcAmount(toAdd);

        const body = {
            ...attentionForCreate,
            medicalServicesIds: medicalServicesIds,
            document: affiliateSelected.searchTag === 'document' ? affiliateSelected.affiliate : null,
            affiliateNumber: affiliateSelected.searchTag === 'affiliateNumber' ? affiliateSelected.affiliate : null,
        };
        setAttentionForCreate(body);
        approveAttention(_.omit(body, ['salesforceProviderId']));
    };

    const handleOnlyDefaultLabServiceSelected = () => {
        return attentionsSelected.find((attention) => defaultLabServicesIds.includes(attention.medicalServiceId)) && attentionsSelected.length === 1;
    };

    const handleChangeCount = (attentionId, count) => {
        reCalcAmount(attentionsSelected.map((item) =>
            item.medicalServiceId === attentionId ? {...item, count: count} : item));
        setAttentionsSelected(attentionsSelected.map((item) =>
            item.medicalServiceId === attentionId ? {...item, count: count} : item));
        setAttentionsForCreate(attentionsForCreate.map((item) =>
            item.medicalServiceId === attentionId ? {...item, count: count} : item));
    };


    const reCalcAmount = (attentions) => {
        let sum = 0;
        attentions.map((att) => {
            if (att.count > 1) {
                for (let i = 0; i < att.count; i++) {
                    sum += att.amount || att.needsToPay;
                }
            } else {
                sum += att.amount || att.needsToPay;
            }
        });
        setAmount(sum ? sum : 0);
    };

    const handleSend = () => {
        onFinish();
    };

    const tableFitsWithoutScroll = (attentionsForCreate?.length || 0) <= MAX_ROWS_WITHOUT_SCROLL;

    const showSendQuote = isSimulation && canSendQuoteEmail && showAmount && attentionsForCreate?.length > 0;


    return (
        <div className={'v2-step-div w-80'}>
            <div className={'v2-create-attention-title-div'}>
                <h3 className={'h3 v2-c-text-title'}>
                    {isSimulation ? 'Coberturas' : 'Crear Atención'}
                </h3>
                <p className={'body-1 c-text-subtitle'}>
                    {isSimulation ? 'Estas son las descripciones de las coberturas que buscaste' : 'Verifique los datos antes de crear la atención'}
                </p>
            </div>
            {affiliateData.length > 0 && affiliateData[0] ? (
                <PersonInfoCard
                    fullName={affiliateData[0].medicalCoverage
                        ? `${affiliateData[0].fullName} - ${affiliateData[0].medicalCoverage}`
                        : affiliateData[0].fullName}
                    attributes={[
                        affiliateSelected.searchTag === 'document' ?
                            `DNI: ${affiliateData[0].documentNumber}` :
                            `Credencial: ${affiliateData[0].affiliateNumber}`,
                        `Prestador: ${provider}`,
                        `Sede: ${branch}`,
                    ]}
                />

            ) : (
                    <div>
                        {setTimeout(() => window.location.reload(), 0)}
                    </div>
            )}
            {approveAttentionState.success ?
                (
                    <div className={'third-step-table-container'}>
                        {createAttentionState.loading ?
                            <div className="mb-50">
                                <Loading/>
                            </div> :
                            (
                                attentionsForCreate?.length > 0 &&
                                <div className={`third-step-table-card ${tableFitsWithoutScroll ? '' : 'third-step-table-card-fixed'}`}>
                                    <Table
                                        autoHeight={tableFitsWithoutScroll}
                                        includeCheckbox={true}
                                        selectedRows={attentionsSelected}
                                        attributes={listData}
                                        rows={attentionsForCreate}
                                        noSelectableRowsIds={defaultLabServicesIds}
                                        rowCount={attentionsForCreate.length}
                                        pageSize={attentionsForCreate.length}
                                        currentPage={1}
                                        onSelectRow={(value) => checkButton(value)}
                                        onPageSizeChange={(value) => console.log(value)}
                                        onPageChange={(value) => console.log(value)}
                                        footerSummary={
                                            <p className={'subtitle-1 v2-c-primary-500'}>
                                                {showAmount ? `Total: $${amount.toLocaleString()}` : 'Total: ***'}
                                            </p>
                                        }
                                    />
                                </div>
                            )
                        }
                        {showSendQuote && <SendQuoteForm provider={provider} branch={branch}/>}
                        {showSendQuote && onExitSimulation &&
                            <div className={'send-quote-actions'}>
                                {/* Ya enviada, Finalizar pasa a ser la accion principal */}
                                <Button size={'medium'}
                                        variant={sendQuoteEmailState.success ? undefined : 'outlined'}
                                        disabled={sendQuoteEmailState.loading}
                                        onClick={onExitSimulation}>Finalizar</Button>
                            </div>}
                        {!isSimulation && <Button size={'medium'} onClick={handleSend}
                                disabled={attentionsSelected.length === 0 || handleOnlyDefaultLabServiceSelected()}>Crear</Button>}
                    </div>
                ) : approveAttentionState.loading ?
                    <div className="mb-50">
                        <Loading/>
                    </div> :
                    approveAttentionState.error &&
                    <div>
                        <CustomAlert text={approveAttentionState.error.message} severity='error'
                                     customText={true}/>
                        <div style={{textAlign: 'center', marginBottom: '20px'}}>
                            <Ebutton classNameButton="eu-btn"
                                     onClick={() => history.push('newMedicalService')}
                                     text="Realizar nueva consulta"/>
                        </div>
                    </div>
            }

        </div>

    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    approveAttentionState: state.home.approveAttentionState,
    attention: state.home.attention,
    affiliateSelected: state.home.affiliateSelected,
    affiliateData: state.home.affiliates,
    createAttentionState: state.home.createAttentionState,
    attentionForCreate: state.home.attentionForCreate,
    branchesProviders: state.home.branchesProviders,
    attentionsSelected: state.home.attentionsSelected,
    branches: state.home.branches,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
    flagAmount: state.home.flagAmount,
    sendQuoteEmailState: state.home.sendQuoteEmailState,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    createAttention: (body) => dispatch(actions.home.createAttentionRequest(body)),
    cleanCreateAttentionState: () => dispatch(actions.home.cleanCreateAttentionState()),
    cleanApproveAttentionState: () => dispatch(actions.home.cleanApproveAttentionState()),
    cleanAttention: () => dispatch(actions.home.cleanAttention()),
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    setAttentionsSelected: (attentionsSelected) => dispatch(actions.home.setAttentionsSelected(attentionsSelected)),
    approveAttention: (body) => dispatch(actions.home.approveAttentionRequest(body)),
});

ThirdStep.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    approveAttentionState: PropTypes.object,
    attention: PropTypes.object,
    createAttentionState: PropTypes.object,
    attentionForCreate: PropTypes.object,
    flagAmount: PropTypes.bool,
    sendQuoteEmailState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThirdStep);
